import './index.less'
import React from 'react'
import { Layout, Menu, Icon } from 'antd'
import { Link } from 'react-router-dom';

const SubMenu = Menu.SubMenu
const { Sider } = Layout;


class Sidebar extends React.Component {

  state = {
    account_type: [],
    openKey: "sub1",
    activeKey: "menu101",
    collapsed: false,
    mode: 'inline',
  }

  componentWillReceiveProps(nextProps) {
    nextProps.accountType && nextProps.accountType.length ? this.setState({account_type:nextProps.accountType}) : null 
  } 

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
      mode: !this.state.collapsed ? 'vertical' : 'inline',
    });
  }

  menuClickHandle = (item) => {
    this.setState({
      activeKey: item.key
    })
  }

  render () {
    if (this.state.account_type) {
      return (
        <Sider
            trigger={null}
            collapsible
            collapsed={this.state.collapsed}
            onCollapse={this.onCollapse}
          >
          <div className="ant-layout-logo"></div>
          <Menu
            mode={this.state.mode} theme="dark"
            // selectedKeys={[activeKey]}
            selectable={false}
            defaultOpenKeys={['main']}
            onClick={this.menuClickHandle}
          >
            <SubMenu
                key="main"
                title={<span><span className="nav-text"><Icon type="database" />Menu</span></span>}
            >
              { this.props.accountType.slice(0, 1).map((menu, index) => (
                <Menu.Item key={index}>
                  <Link to={menu.path}>{menu.menuTitle}</Link>
                </Menu.Item>
              ))}
            </SubMenu>
          </Menu>
          <div className="sider-trigger">
            <Icon
                className="trigger"
                type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
                onClick={this.toggle}
              />
          </div>
        </Sider>
      )
    } else {
      return (<div>loading...</div>) 
    }
  }
}

export default Sidebar



// WEBPACK FOOTER //
// ./src/components/Sidebar/index.jsx